import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

// @material-ui/icons
import Email from "@material-ui/icons/Email";
// import LockOutline from "@material-ui/icons/LockOutline";
import Check from "@material-ui/icons/Check";
import Close from "@material-ui/icons/Close";
import LockOutline from "@material-ui/icons/LockOutlined";

// core components
import GridContainer from "../../../components/Grid/GridContainer.js";
import GridItem from "../../../components/Grid/GridItem.js";
import Button from "../../../components/CustomButtons/Button.js";
import CustomInput from "../../../components/CustomInput/CustomInput.js";
import Card from "../../../components/Card/Card.js";
import CardBody from "../../../components/Card/CardBody.js";

import SweetAlert from "react-bootstrap-sweetalert";

import 'react-phone-input-2/lib/style.css'
import PhoneInput from 'react-phone-input-2'
import startsWith from 'lodash.startswith';

import styles from "../../../assets/jss/material-dashboard-pro-react/views/registerPageStyle";
import validationFormStyles from "../../../assets/jss/material-dashboard-pro-react/views/validationFormsStyle.js";
import alertStyles from "../../../assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";

const useStyles = makeStyles(styles);
const useValidationFormStyles = makeStyles(validationFormStyles);
const useAlertStyles = makeStyles(alertStyles);

export default function RegisterPage() {
    const history = useHistory();
    const validationClasses = useValidationFormStyles();
    const classes = useStyles();
    const alertClasses = useAlertStyles();
    
    const [error, setError] = React.useState("Passwords must be at least 6 characters. Passwords must have at least one digit. Passwords must have at least one lowercase character. Passwords must have at least one uppercase character.");
    const [email, setEmail] = React.useState('');
    const [password, setPassword] = React.useState('');
    const [phoneNumber, setPhoneNumber] = React.useState('');
    const [confirmPassword, setConfirmPassword] = React.useState('');
    const [EmailRequiredState, setEmailRequiredState] = React.useState("");
    const [PasswordRequiredState, setPasswordRequiredState] = React.useState("");
    const [ConfirmPasswordRequiredState, setConfirmPasswordRequiredState] = React.useState("");
    const [ConfirmTCRequiredState, setConfirmTCRequiredState] = React.useState("");
    const [checked, setChecked] = React.useState([]);
    const [DisbleButtons, setDisableButtons] = React.useState(false);
    const [isPhoneNumberValid, setIsPhoneNumberValid] = React.useState('false');
    const [alert, setAlert] = React.useState(null);

    const searchParams = new URLSearchParams(window.location.search);
    const params = { productCode: searchParams.get('productCode') || '', action: searchParams.get('action') || '', };

    const [cardAnimaton, setCardAnimation] = React.useState("cardHidden");

    React.useEffect(() => {
        let id = setTimeout(function () {
            setCardAnimation("");
        }, 700);
        // Specify how to clean up after this effect:
        return function cleanup() {
            window.clearTimeout(id);
        };
    });

    useEffect(() => {
        if (params.productCode !== '') {
            if (params.action === 'add') {
                var bearerToken = localStorage.getItem("careXactSOS_BearerToken");

                if (bearerToken !== null) {
                    // redirect to the devices add device wizard if they have a login already
                    history.push("/admin/devices?action=add&productCode=" + params.productCode);
                }
            }
        }
    }, []);

    const handleToggle = value => {
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }
            setChecked(newChecked);
    };

    const verifyLength = (value, length) => {
        if (value === null) return false;

        if (value.length >= length) {
            return true;
        }
        return false;
    };

    const verifyEmail = (value) => {
        if (value === null) return false;

        var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (emailRex.test(value)) {
            return true;
        }
        return false;
    };

    function validateFormFields() {
        var result = true;

        if (email === "") {
            setEmailRequiredState("error");
            result = false;
        }
        if (confirmPassword === "") {
            setConfirmPasswordRequiredState("error");
            result = false;
        }
        if (password === "") {
            setPasswordRequiredState("error");
            result = false;
        } else {
            if (password !== confirmPassword) {
                setPasswordRequiredState("error");
                setConfirmPasswordRequiredState("error");
                result = false;
            }
        }

        if (checked[0] !== 1) {
            setConfirmTCRequiredState("error");
            result = false;
        } else {
            setConfirmTCRequiredState("success");
        }

        if (isPhoneNumberValid === false) {
            showAlert("Invalid Phone Number", "The account holder phone number must start with a valid country code.")
            result = false;
        }

        return result;
    }
    function handleErrors(response) {
        if (!response.ok) {
            throw Error(response.statusText);
        }
        return response.json();
    }

    const handleSignUp = async (event) => {

        if (validateFormFields() === false) {
            if (password !== confirmPassword) {
                setError("Password and Confirm password do not match.");
            }
            else {
                if (checked[0] !== 1) {
                    setError("Confirm you agree to the terms and conditions before proceeding.");
                } else {
                    setError("Update the required fields and try again.");
                }
            }
        }
        else {
            setError("");
            const json = {
                Email: email.trim(),
                Password: password,
                ConfirmPassword: confirmPassword,
                PhoneNumber: phoneNumber
            }

            setDisableButtons(true);

            const apiURL = process.env.REACT_APP_API_BASE_URL;
            const subscriptionKey = process.env.REACT_APP_API_SUBSCRIPTION_KEY;
            const headers = { 'Content-Type': 'application/json', 'Ocp-Apim-Subscription-Key': subscriptionKey };

            fetch(apiURL + 'api/Account/Register', {
                method: 'POST',
                body: JSON.stringify(json),
                headers: headers
            })
                .then(response => {
                    if (!response.ok) {
                        throw Error(response.statusText);
                    }
                    else {
                        // auto login if account created successfully
                        fetch(apiURL + 'Token', {
                            method: 'POST',
                            body: "grant_type=password&username=" + email + "&password=" + password,
                            headers: headers
                        })
                            .then(handleErrors)
                            .then(response => {
                                localStorage.setItem("careXactSOS_BearerToken", response.access_token);
                                localStorage.setItem("careXactSOS_ApiURL", apiURL);
                                localStorage.setItem("careXactSOS_SubscriptionKey", subscriptionKey);

                                if (params.productCode !== '') {
                                    if (params.action === 'add') {
                                        var bearerToken = localStorage.getItem("careXactSOS_BearerToken");

                                        if (bearerToken !== null) {
                                            // redirect to the devices add device wizard now user has a login
                                            history.push("/admin/devices?action=add&productCode=" + params.productCode);
                                        }
                                    }
                                }
                                else {
                                    history.push("/");
                                }
                            })
                            .catch(error => {
                                localStorage.removeItem("careXactSOS_BearerToken");
                                setError("Something went wrong. Please check your email and password then try again, or use the reset password feature above.");
                                console.log(error.message);
                                setDisableButtons(false);
                            });
                    }
                })
                .catch(error => {
                    setError("Something went wrong. Passwords must be at least 6 characters. Passwords must have at least one digit. Passwords must have at least one lowercase character. Passwords must have at least one uppercase character.");
                    console.log(error.message);
                    setDisableButtons(false);
                });
        }
    }
    function NewlineText(props) {
        const text = props.text;
        const newText = text.split('.').map(str => <div>{str}</div>);
        return newText;
    }
    function handlePhoneNumberOnChange(value, countryData) {

        // if truthy then append a + so when we POST to db phone numbers have a +
        if (value) {
            value = value.startsWith('+') ? value : "+" + value;

            // format +610414999888 as +61414999888.  International format country dial code replaces the leading 0
            value = value.startsWith('+' + countryData.dialCode + '0') ? value.replace('+' + countryData.dialCode + '0', '+' + countryData.dialCode) : value;
        }

        const isPhoneValid = isPhoneNumberFormatValid(value, countryData);

        setPhoneNumber(value);
        setIsPhoneNumberValid(isPhoneValid);
    };
    function isPhoneNumberFormatValid(inputNumber, country) {

        if (country?.dialCode) {
            return startsWith(inputNumber, "+" + country.dialCode) || startsWith("+" + country.dialCode, inputNumber);
        }

        return false;
    };

    const hideAlert = () => {
        setAlert(null);
    };

    const showAlert = (title, message) => {
        setAlert(
            <SweetAlert
                error
                style={{ display: "block", marginTop: "-100px", width: "400px" }}
                title={title}
                onConfirm={hideAlert}
                onCancel={hideAlert}
                confirmBtnCssClass={`${alertClasses.button} ${alertClasses.success}`}
            >
                <div>
                    {message}
                </div>
            </SweetAlert>
        );
    };

    return (
        <div className={classes.container}>
        <GridContainer justify="center">
            <GridItem xs={12} sm={8} md={8}>
            <Card login className={classes[cardAnimaton]}>
            <h2 className={classes.cardTitle}>Sign Up</h2>
            <CardBody>
                {alert}
                <GridContainer justify="center">
                    <GridItem xs={12}>
                    <form className={classes.form}>
                        <CustomInput
                            labelText="Email..."
                            id="email"
                            error={EmailRequiredState === "error"}
                            formControlProps={{
                                fullWidth: true
                            }}
                            inputProps={{
                                onChange: event => {
                                    verifyEmail(event.target.value) === true ? setEmailRequiredState("success") : setEmailRequiredState("error");
                                    setEmail(event.target.value);
                                },
                                value: email,
                                endAdornment: EmailRequiredState === "error" ? (<InputAdornment position="end"><Close className={validationClasses.danger} /></InputAdornment>) : (<InputAdornment position="end"><Email className={classes.inputAdornmentIcon} /></InputAdornment>)
                            }}
                        />
                        <CustomInput
                            labelText="Password"
                            id="password"
                            error={PasswordRequiredState === "error"}
                            formControlProps={{
                                fullWidth: true
                            }}
                            inputProps={{
                                onChange: event => {
                                    verifyLength(event.target.value, 1) === true ? setPasswordRequiredState("success") : setPasswordRequiredState("error");
                                    setPassword(event.target.value);
                                },
                                endAdornment: PasswordRequiredState === "error" ? (<InputAdornment position="end"><Close className={validationClasses.danger} /></InputAdornment>) : (<InputAdornment position="end"><LockOutline className={classes.inputAdornmentIcon} /></InputAdornment>),
                                type: "password",
                                autoComplete: "off"
                            }}
                        />
                        <CustomInput
                            labelText="Confirm password"
                            id="confirmPassword"
                            error={ConfirmPasswordRequiredState === "error"}
                            formControlProps={{
                                fullWidth: true
                            }}
                            inputProps={{
                                onChange: event => {
                                    verifyLength(event.target.value, 1) === true ? setConfirmPasswordRequiredState("success") : setConfirmPasswordRequiredState("error");
                                    setConfirmPassword(event.target.value);
                                },
                                endAdornment: ConfirmPasswordRequiredState === "error" ? (<InputAdornment position="end"><Close className={validationClasses.danger} /></InputAdornment>) : (<InputAdornment position="end"><LockOutline className={classes.inputAdornmentIcon} /></InputAdornment>),
                                type: "password",
                                autoComplete: "off"
                            }}
                            />
                            <PhoneInput
                                placeholder="Account Holder Phone Number"
                                autoFormat={false}
                                onlyCountries={['au', 'nz']}
                                value={phoneNumber || ''}
                                onChange={(value, countryData) => {
                                    // If the value is empty, set it directly without prepending the country code
                                    if (!value || value.length === 1) {
                                        handlePhoneNumberOnChange(value, countryData);
                                        return;
                                    }

                                    // weird edge case where if a user types a number then selects a country the component doesn't add the country code automatically
                                    if (countryData?.dialCode && !value.startsWith(countryData?.dialCode)) {
                                        value = `+${countryData.dialCode}${value}`;
                                    }

                                    handlePhoneNumberOnChange(value, countryData);
                                }}
                                countryCodeEditable={true}
                                prefix={(phoneNumber === '000' || phoneNumber === '111') ? "" : "+"}
                                isValid={(inputNumber, country, countries) => {
                                    // Ensure a country code is selected
                                    return countries.some((country) => {
                                        return (
                                            inputNumber.startsWith(country.dialCode) ||
                                            country.dialCode.startsWith(inputNumber)
                                        );
                                    });
                                }}
                                inputStyle={{ width: '100%' }}
                                />
                    <FormControlLabel
                        classes={{
                        root: classes.checkboxLabelControl,
                        label: classes.checkboxLabel
                        }}
                        control={
                        <Checkbox
                            tabIndex={-1}
                            onClick={() => handleToggle(1)}
                            checked={checked[0]}
                            checkedIcon={
                            <Check className={classes.checkedIcon} />
                            }
                            icon={<Check className={classes.uncheckedIcon} />}
                            classes={{
                            checked: classes.checked,
                            root: classes.checkRoot
                            }}
                        />
                        }
                        label={
                        <span>
                            I agree to the{" "}
                                <a href="https://www.tunstallhealthcare.com.au/s/Tunstall-Gem4-SOS-Pendant_Customer-Terms-and-Conditions_Final_9-December-2022.pdf" target="_blank">terms and conditions</a>.
                        </span>
                        }
                    />
                    <div className={classes.left}>
                        <Button round color="blueSky" onClick={event => handleSignUp(event)} disabled={DisbleButtons===true}>Sign Up</Button>
                        <br />{error && <><small style={{ color: 'red' }}><NewlineText text={error} /></small></>}
                    </div>
                    </form>
                </GridItem>
                </GridContainer>
            </CardBody>
            </Card>
        </GridItem>
        </GridContainer>
    </div>
    );
}
